module.exports = __webpack_public_path__ + "assets/imgs/map@2x.dfa4fbbad5e0a4833c9037d65b95c548.png";